import React from "react";
import StyledItemGrid from "./ItemGrid.styled";

const ItemGrid = StyledItemGrid;

export default StyledItemGrid;
